//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import { t } from '@web-solutions/module-localization';
import getLocale from 'src/localization/get-locale';

function DynamicMultiPage({ pageConfig, onNext, onPrev }) {
  const pageAnswers = useStore((state) => state.pageAnswers);
  const setPageAnswer = useStore((state) => state.setPageAnswer);

  const { currentIndex } = useNav();
  const locale = getLocale();

  const currentAnswer = pageAnswers[pageConfig.id]?.answer || [];
  const [hasSelection, setHasSelection] = useState(currentAnswer.length > 0);

  const handleChange = (value) => {
    setPageAnswer(pageConfig.id, {
      answer: value,
      title: pageConfig.title,
    });
    setHasSelection(value.length > 0);
  };

  const handleContinue = () => {
    if (!hasSelection) return;

    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
      answer: currentAnswer.join(', '),
    });

    onNext();
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={'wrapper-info'}>
        <Title tag='h2'>{pageConfig.title[locale]}</Title>
        {pageConfig.subTitle && (
          <Text size='m' medium className='description'>
            {pageConfig.subTitle[locale]}
          </Text>
        )}
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={currentAnswer} onChange={handleChange}>
          {pageConfig.options.map((option) => (
            <MultiOption key={option.value} value={option.value}>
              {option.emoji && <span>{option.emoji}</span>}
              {option.text[locale]}
            </MultiOption>
          ))}
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={hasSelection ? '' : 'disabled'}
          title={t('onboarding.analyzeBody.continue')}
          onClick={handleContinue}
        />
      </div>
    </div>
  );
}

export default DynamicMultiPage;
